import React from "react";
import { Typography } from "@mui/material";
import Slider from "@mui/material/Slider";

export default function NonLinearSlider({
  marks,
  header,
  min,
  max,
  step,
  value,
  setValue
}) {
  

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const scale = (value) => {
    const previousMarkIndex = Math.floor(value / 25);
    const previousMark = marks[previousMarkIndex];
    const remainder = value % 25;
    if (remainder === 0) {
      return previousMark.scaledValue;
    }
    const nextMark = marks[previousMarkIndex + 1];
    const increment = (nextMark.scaledValue - previousMark.scaledValue) / 25;
    return remainder * increment + previousMark.scaledValue;
  };

  return (
    <div>
      <Typography variant="standard">{header}</Typography>
      <Slider
        value={value}
        min={min}
        step={step}
        max={max}
        marks={marks}
        scale={scale}
        onChange={handleChange}
        valueLabelDisplay={"auto"}
      />
    </div>
  );
}
